import React, { useContext } from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { textBody } from '../../styles/typography';

import CardContentContext from './CardContentContext';
import {
  useApplyDisplaySubtitleOnSmallDeviceStyle,
  useApplyHasSubtitleHoverStyle,
  useApplySubtitleStyle,
} from './logic';

export const CardContentContent = ({
  children,
  className,
  as: Component = 'div',
  ...props
}: DefaultBsComponent) => {
  const context = useContext(CardContentContext);
  const subtitleStyle = useApplySubtitleStyle();
  const displaySubtitleOnSmallDeviceStyle =
    useApplyDisplaySubtitleOnSmallDeviceStyle();
  const hasSubtitleHoverStyle = useApplyHasSubtitleHoverStyle();

  return (
    <Component
      className={classNames(
        'CardContentContent',
        className,
        'hidden mt-8',
        textBody,
        subtitleStyle,
        context?.displaySubtitleOnSmallDevice &&
          displaySubtitleOnSmallDeviceStyle,
        hasSubtitleHoverStyle
      )}
      {...props}
    >
      <span
        className={classNames(
          context?.hasSubtitleHover &&
            'delay-100 opacity-0 md:group-hover:opacity-100 transition-all duration-500 ease-in-out'
        )}
      >
        {children}
      </span>
    </Component>
  );
};
